export default function () {
  return {
    isFirstLogin: false,
    isEmailVerified: false,
    isComingSoonSignUp: false,
    token: null,
    logoutResolver: null,
    tokenRefreshRequiredTimeout: null,
    tokenRefreshRequired: false,
    tokenExpireTimeout: null,
    tokenExpired: false,
    tokenRefreshLoading: false,
    expirationTime: null,
    temporaryToken: null,
    loginHistoryDataAll: [],
    loginHistoryDataAllTotal: null,
    loginHistoryDataAllLoading: false,
    logoutLoading: false,
    mfa: false,
    mfaLoading: false,
  };
}
